import { render } from "./GridContactDetalii.vue?vue&type=template&id=66c35058&scoped=true&ts=true"
import script from "./GridContactDetalii.vue?vue&type=script&lang=ts"
export * from "./GridContactDetalii.vue?vue&type=script&lang=ts"

import "./GridContactDetalii.vue?vue&type=style&index=0&id=66c35058&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c35058"]])

export default __exports__